// eslint-disable-next-line no-restricted-imports
import {
  LegalClientBodyFragment,
  Query_LegalClientController_GetList_AllOf_1_List_Items_Bodies_Items_Status,
} from 'api/generated/graphql';
import { LegalClientBodyEntity, LegalClientBodyType } from 'api/types/entity';

export const parseLegalClientBodyEntity = (
  data: LegalClientBodyFragment
): LegalClientBodyEntity => ({
  id: data.id,
  name: data.name,
  type: LegalClientBodyType[data.type],
  otherType: data.otherType ?? undefined,
  createdAt: new Date(data.createdAt),
  archived:
    data.status ===
    Query_LegalClientController_GetList_AllOf_1_List_Items_Bodies_Items_Status.Archived,
});
